import { forwardRef, useCallback } from 'react';

import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import IconButton from '@mui/material/IconButton';
import type { SnackbarKey } from 'notistack';
import { SnackbarContent, useSnackbar } from 'notistack';
import type { CSSProperties } from 'react';

import { ReactComponent as CloseIcon } from 'assets/images/ui/icon-close.svg';
import { ReactComponent as IconAlert } from 'assets/images/ui/icon-warning.svg';

interface Props {
  key: SnackbarKey;
  message: string;
  maxWight?: number;
}

const WidgetError = forwardRef<HTMLDivElement, Props>(({ message, key, maxWight }, ref) => {
  const cardStyles = {
    backgroundColor: 'var(--negative)',
    borderRadius: '12px',
    margin: `${maxWight ? '0 32px 0 32px' : 0}`,
    minWidth: `${maxWight ? `${maxWight - 64}px` : '100%'}`,
    overflow: 'hidden',
    position: 'relative',
    right: '16px',
  };

  const actionStyles = {
    display: 'flex',
    justifyContent: 'space-between',
    padding: '12px',
  };

  const contentStyles = {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'nowrap',
    gap: '14px',
  };

  const typographyStyles: CSSProperties = {
    color: '#fff',
    fontSize: '16px',
    fontWeight: 400,
    lineHeight: '24px',
    whiteSpace: 'normal',
    wordBreak: 'break-word',
  };

  const expandStyles = {
    color: '#fff',
    height: '32px',
    padding: 0,
    transition: 'all .2s',
    width: '32px',
  };

  const iconAlertStyles = {
    alignItems: 'center',
    color: '#fff',
    display: 'flex',
    height: '24px',
    justifyContent: 'center',
    padding: 0,
    transition: 'all .2s',
    width: '24px',
  };

  const iconsStyles = {
    marginLeft: 'auto',
  };

  const { closeSnackbar } = useSnackbar();

  const handleDismiss = useCallback(() => {
    closeSnackbar(key); // Используйте id для закрытия снекбара
  }, [closeSnackbar]);

  return (
    <SnackbarContent ref={ref} style={{ right: '3px' }}>
      <Card style={cardStyles as CSSProperties}>
        <CardActions style={actionStyles}>
          <div style={contentStyles as CSSProperties}>
            <div style={iconAlertStyles as CSSProperties}>
              <IconAlert height='20px' width='20px' />
            </div>
            <span style={typographyStyles}>{message}</span>
          </div>
          <div style={iconsStyles}>
            <IconButton size='small' style={expandStyles} onClick={handleDismiss}>
              <CloseIcon />
            </IconButton>
          </div>
        </CardActions>
      </Card>
    </SnackbarContent>
  );
});

WidgetError.displayName = 'WidgetError';

export default WidgetError;
